import React from "react";
import PageHero from "../components/PageHero";
import ContactSection from "../components/ContactSection";

export default function ContactPage() {
  return (
    <div data-testid="contact-page">
      <PageHero
        eyebrow="Contact"
        title="Talk to a senior cybersecurity consultant"
        subtitle="Book a 45-minute strategy call, request a callback or send us a message. We respond within one business day."
      />
      <ContactSection />
    </div>
  );
}
